var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"href":"https://www.signledger.com","target":"_blank"}},[_vm._v("SignLedger LLC")]),_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" ")])]),_c('div',{staticClass:"mfs-auto"},[_vm._v(" "+_vm._s(_vm.onlineStatus)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }